import Referral from "../../entities/referral";

/**
 * Referral actions
 *
 * Call order:
 *
 * REFERRAL_SAVE_QUEUE:	adds the item to the save queue
 * --> REFERRAL_SAVE:	modifies the state
 * --> REFERRAL_SAVE_SUCCESS: if all went well
 * --> REFERRAL_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail REFERRAL_SAVE_QUEUE is during the call to REFERRAL_SAVE,
 * as adding an item to the queue should never fail.
 */

export const REFERRAL_FETCH_ONE_QUEUE: any = 'REFERRAL_FETCH_ONE_QUEUE';
export const REFERRAL_FETCH_SUCCESS: any = 'REFERRAL_FETCH_SUCCESS';
export const REFERRAL_FETCH_FAILURE: any = 'REFERRAL_FETCH_FAILURE';
export const REFERRAL_FETCH_ONE_SUCCESS: any = 'REFERRAL_FETCH_ONE_SUCCESS';
export const REFERRAL_FETCH_ONE_FAILURE: any = 'REFERRAL_FETCH_ONE_FAILURE';

export const REFERRAL_SAVE: any = 'REFERRAL_SAVE';
export const REFERRAL_SAVE_QUEUE: any = 'REFERRAL_SAVE_QUEUE';
export const REFERRAL_SAVE_SUCCESS: any = 'REFERRAL_SAVE_SUCCESS';
export const REFERRAL_SAVE_FAILURE: any = 'REFERRAL_SAVE_FAILURE';

export const REFERRAL_SAVE_MANY: any = 'REFERRAL_SAVE_MANY';
export const REFERRAL_SAVE_MANY_QUEUE: any = 'REFERRAL_SAVE_MANY_QUEUE';
export const REFERRAL_SAVE_MANY_SUCCESS: any = 'REFERRAL_SAVE_MANY_SUCCESS';
export const REFERRAL_SAVE_MANY_FAILURE: any = 'REFERRAL_SAVE_MANY_FAILURE';

export const REFERRAL_REMOVE: any = 'REFERRAL_REMOVE';
export const REFERRAL_REMOVE_QUEUE: any = 'REFERRAL_REMOVE_QUEUE';
export const REFERRAL_REMOVE_SUCCESS: any = 'REFERRAL_REMOVE_SUCCESS';
export const REFERRAL_REMOVE_FAILURE: any = 'REFERRAL_REMOVE_FAILURE';

export const REFERRAL_RESTORE: any = 'REFERRAL_RESTORE';
export const REFERRAL_RESTORE_QUEUE: any = 'REFERRAL_RESTORE_QUEUE';
export const REFERRAL_RESTORE_SUCCESS: any = 'REFERRAL_RESTORE_SUCCESS';
export const REFERRAL_RESTORE_FAILURE: any = 'REFERRAL_RESTORE_FAILURE';

export const REFERRAL_RESTORE_MANY: any = 'REFERRAL_RESTORE_MANY';
export const REFERRAL_REMOVE_MANY: any = 'REFERRAL_REMOVE_MANY';

/* Fetch actions */
export const fetchReferralSuccess = (referrals: Referral[], partial: boolean, lastFetch: number) => ({type: REFERRAL_FETCH_SUCCESS, referrals, partial, lastFetch});
export const fetchReferralFailure = (err: any) => {
		console.error('ReferralAction: fetchReferralFailure', err);
		return {type: REFERRAL_FETCH_FAILURE, err};
};
export const fetchOneReferralQueue = (referralId: string) => ({type: REFERRAL_FETCH_ONE_QUEUE, referralId});
export const fetchOneReferralSuccess = (referral: Referral) => ({type: REFERRAL_FETCH_ONE_SUCCESS, referral});
export const fetchOneReferralFailure = (id: string, err: any) => {
		console.error('ReferralAction: fetchOneReferralFailure', err);
		return {type: REFERRAL_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveReferral = (referral: Referral) => {
    // console.debug('⮂ REFERRAL_SAVE action', referral?.id);
    return {type: REFERRAL_SAVE, referral};
}
export const saveReferralQueue = (referral: Referral, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ REFERRAL_SAVE_QUEUE action', referral?.id);
    return {type: REFERRAL_SAVE_QUEUE, referral, onQueued};
}
export const saveReferralSuccess = (referral: Referral) => {
    // console.debug('⮂ REFERRAL_SAVE_SUCCESS action', referral?.id);
    return {type: REFERRAL_SAVE_SUCCESS, referral};
}
export const saveReferralFailure = (referral: Referral, status: number, message: string) => {
    console.warn(`⮂ REFERRAL_SAVE_FAILURE error saving referral: HTTP ${status}: ${message}`, referral?.id);
    return {type: REFERRAL_SAVE_FAILURE, referral, status, message};
};

/* SaveMany actions */
export const saveManyReferrals = (referrals: Referral[]) => {
    // console.debug('⮂ REFERRAL_SAVE_MANY action', referrals?.map(referral => referral?.id).join(','));
    return {type: REFERRAL_SAVE_MANY, referrals};
}
export const saveManyReferralsQueue = (referrals: Referral[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ REFERRAL_SAVE_MANY_QUEUE action', referrals?.map(referral => referral.id).join(','));
    return {type: REFERRAL_SAVE_MANY_QUEUE, referrals, onQueued};
}

export const saveManyReferralsSuccess = (referrals: Referral[]) => {
    // console.debug('⮂ REFERRAL_SAVE_MANY_SUCCESS action', referrals?.map(referral => referral.id).join(','));
    return {type: REFERRAL_SAVE_MANY_SUCCESS, referrals};
}
export const saveManyReferralsFailure = (referrals: Referral[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_REFERRALS_FAILURE Error saving referrals: HTTP ${status}: ${message}`, referrals?.map(referral => referral.id).join(','));
		return {type: REFERRAL_SAVE_MANY_FAILURE, referrals, status, message};
};

/* Remove actions */
export const removeReferral = (referral: Referral) => ({ type: REFERRAL_REMOVE, referral });
export const removeReferralQueue = (referral: Referral) => ({ type: REFERRAL_REMOVE_QUEUE, referral });
export const removeReferralSuccess = (referral: Referral) => ({ type: REFERRAL_REMOVE_SUCCESS, referral });
export const removeReferralFailure = (referral: Referral, status: number, message: string) => {
	console.error(`Redux: removeReferralFailure Error removing referral: HTTP ${status}: ${message}`);
	return ({ type: REFERRAL_REMOVE_FAILURE, referral, status, message });
};

/* Restore actions */
export const restoreReferral = (referral: Referral) => ({ type: REFERRAL_RESTORE, referral });
export const restoreReferralQueue = (referral: Referral) => ({ type: REFERRAL_RESTORE_QUEUE, referral });
export const restoreReferralSuccess = (referral: Referral) => ({ type: REFERRAL_RESTORE_SUCCESS, referral });
export const restoreReferralFailure = (referral: Referral, status: number, message: string) => {
	console.error(`Redux: restoreReferralFailure Error restoring referral: HTTP ${status}: ${message}`);
	return ({ type: REFERRAL_RESTORE_FAILURE, referral, status, message });
};

/* RestoreMany actions */
export const restoreManyReferrals = (referrals: Referral[]) => ({ type: REFERRAL_RESTORE_MANY, referrals });

/* RemoveMany actions */
export const removeManyReferrals = (referrals: Referral[]) => ({ type: REFERRAL_REMOVE_MANY, referrals });